import React from 'react';

// This file needs to import from react-router since it's the abstraction
/* eslint-disable no-restricted-imports */
import { Redirect } from 'react-router-dom';

export function Navigate({ to }: { to?: string }) {
  return to ? <Redirect to={to} /> : null;
}
